/**
 * Resolves the mail ingest domain based on the current deployment environment.
 *
 * Domain mapping is deterministic per environment — the backend uses the same
 * `MAIL_INGEST_DOMAIN` env var, so the frontend preview always matches.
 */
import { config } from '@/config';

const ENV_DOMAIN_MAP: Record<string, string> = {
  development: 'mail-ci.tappeer.dev',
  ci: 'mail-ci.tappeer.dev',
  staging: 'mail-staging.tappeer.dev',
  preprod: 'mail-preprod.tappeer.dev',
  production: 'mail.tappeer.app'
} as const;

/** Default domain when environment is unknown */
const DEFAULT_DOMAIN = 'mail.tappeer.app';

/**
 * Get the mailbox domain for the current environment.
 */
export function getMailIngestDomain(): string {
  return ENV_DOMAIN_MAP[config.env] ?? DEFAULT_DOMAIN;
}
